/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Loader from './components/Loader';
// actions
import {
  logIn,
  // getAvailablePlans,
  // getTransactions,
  getBookmarks,
  // getUsersByClientId,
} from './store/User/userActions';
import {
  getStructure,
  getClientLevel,
  // getClientLogo,
  getDocuments,
  getPages,
  getRightNavigation,
  getClientGlossary,
  getRelatedContent,
} from './store/Client/clientActions';

// helper file
import { LEVELS } from './assets/constants/strings';
import { GetUserQueries } from './store/Revealr/revealrActions';
import { isApiOnly } from './services/entitlements';

const Persistence = ({
  children,
  // login logic
  user,
  logIn,
  // populate user state
  userState,
  // getTransactions,
  getBookmarks,
  // getUsersByClientId,
  // populate client state
  clientState,
  docState,
  getStructure,
  getClientLevel,
  // getClientLogo,
  getDocuments,
  getPages,
  getRightNavigation,
  getClientGlossary,
  getRelatedContent,
  queriesState,
  GetUserQueries,
}) => {
  const IsLoggedIn = localStorage.getItem('loggedIn') === 'true';

  useEffect(() => {
    if (!user && IsLoggedIn) logIn(null, null);
  }, []);

  const [initUser, setInitUser] = useState(false);
  const [initClient, setInitClient] = useState(false);

  //#region Populate reducers

  const populateUser = () => {
    setInitUser(true);
    // const { cards, transactions, bookmarks, usersByClient } = userState;
    const { bookmarks } = userState;

    // if (
    //   (!cards && user.isCorporate && user.isAdmin) ||
    //   (!cards && user && user.accountType === 'individual' && user.isActive)
    // )
    //   getCards();
    // if (
    //   (!transactions && user.isCorporate && user.isAdmin) ||
    //   (!transactions &&
    //     user &&
    //     user.accountType === 'individual' &&
    //     user.isActive)
    // )
    //   getTransactions();
    if (!bookmarks && !isApiOnly(user)) getBookmarks();
    // if (!usersByClient && user.isCorporate && user.isAdmin)
    //   getUsersByClientId();
  };

  const populateClient = () => {
    setInitClient(true);
    const {
      spStructure: structure,
      levelOneList,
      levelTwoList,
      levelThreeList,
      levelFourList,
      // logo,
      documents,
      rightNav,
      glossaryList,
      relatedContent,
    } = clientState;

    if (structure === null) getStructure();
    if (levelOneList === null) getClientLevel(LEVELS.ONE);
    if (levelTwoList === null) getClientLevel(LEVELS.TWO);
    if (levelThreeList === null) getClientLevel(LEVELS.THREE);
    if (levelFourList === null) getClientLevel(LEVELS.FOUR);
    // if (logo === null) getClientLogo();
    if (rightNav === null) getRightNavigation();
    if (glossaryList === null) getClientGlossary();
    if (relatedContent === null) getRelatedContent();
    if (documents === null) getDocuments();

    populateQueries();
  };

  const populateQueries = () => {
    setInitUser(true);

    const { queries } = queriesState;

    if (!queries) GetUserQueries();
  };

  // need to populate pages in separate useEffect to ensure documents have loaded
  // useEffect(() => {
  //   const { documents, pages, proccessesRunning } = clientState;
  //   if (
  //     documents !== null &&
  //     pages === null &&
  //     // < 100 to make sure we do not call it twice
  //     proccessesRunning < 100 &&
  //     // if inside document page, only fire after document finished
  //     docState.loading === false
  //   ) getPages();
  // }, [clientState, docState]);

  //#endregion

  useEffect(() => {
    if (
      user &&
      // isActive is determined by any paid plans having an end date larger than now or free trial being selected
      user.isActive &&
      // JWT required for the .NET content gateway (spKey is injected server-side)
      user.token
    ) {
      if (initUser === false) populateUser();
      // only populate content if user paid or has free trial
      if (
        // first condition for paid plans
        user.customerId !== null
      )
        if (initClient === false && !isApiOnly(user)) populateClient();
    }
  }, [user]);

  useEffect(() => {
    if (
      user &&
      // isActive is determined by any paid plans having an end date larger than now or free trial being selected
      user.isActive &&
      // JWT required for the .NET content gateway (spKey is injected server-side)
      user.token
    ) {
      if (initUser === false) populateUser();
      // only populate content if user paid or has free trial
      if (
        // first condition for paid plans and second for free trial
        user.customerId !== null ||
        (user.daysLeft !== null && user.daysLeft >= 0)
      )
        if (initClient === false && !isApiOnly(user)) populateClient();
    }
  }, [user]);

  return (
    <React.Fragment>
      {!user && IsLoggedIn ? (
        <div className='page-loader-wrapper'>
          <Loader text='Authenticating...' />
        </div>
      ) : (
        children
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  userState: state.user,
  clientState: state.client,
  docState: state.document,
  queriesState: state.queries,
});

const mapDispatchToProps = {
  // user Actions
  logIn,
  // getAvailablePlans,
  // getTransactions,
  getBookmarks,
  // client Actions
  getStructure,
  getClientLevel,
  // getClientLogo,
  getDocuments,
  getPages,
  getRightNavigation,
  getClientGlossary,
  getRelatedContent,
  // getUsersByClientId,
  GetUserQueries,
};

export default connect(mapStateToProps, mapDispatchToProps)(Persistence);
